import { apiGet, apiPost, apiPut, apiRequest } from '@/utils/request';
import { parsePaginatedResponseFull } from '@/utils/apiResponse';
import { DEFAULT_PAGE_SIZE } from '@/constants/api';
import type {
  ReachPlanItem,
  ReachPlanDetail,
  ReachRecordItem,
  RecordDetailItem,
} from '@/types/reachPlan';

export const reachPlansApi = {
  /** 触达计划列表 */
  list: (params: Record<string, unknown> = {}) =>
    apiGet('/reach-plans/index', { per_page: DEFAULT_PAGE_SIZE, page: 1, ...params }).then((d) =>
      parsePaginatedResponseFull<ReachPlanItem>(d, { page: 1, per_page: DEFAULT_PAGE_SIZE }),
    ),

  /** 计划详情 */
  show: (id: number) => apiGet('/reach-plans/show', { id }) as Promise<ReachPlanDetail>,

  /** 创建计划 */
  create: (data: Record<string, unknown>) => apiPost('/reach-plans/create', data),

  /** 更新计划 */
  update: (data: Record<string, unknown>) => apiPut('/reach-plans/update', data),

  /** 暂停/恢复计划 */
  toggle: (id: number) => apiPut('/reach-plans/toggle', { id }),

  /** 删除计划 */
  delete: (id: number) => apiRequest('/reach-plans/delete', { method: 'DELETE', data: { id } }),

  /** 触达记录列表 */
  records: (params: Record<string, unknown> = {}) =>
    apiGet('/reach-plans/records', { per_page: DEFAULT_PAGE_SIZE, page: 1, ...params }).then((d) =>
      parsePaginatedResponseFull<ReachRecordItem>(d, { page: 1, per_page: DEFAULT_PAGE_SIZE }),
    ),

  /** 下载导入模板 */
  downloadTemplate: () => apiGet('/reach-plans/download-template') as Promise<{ url: string }>,

  /** 发送详情列表 */
  recordDetails: (params: Record<string, unknown> = {}) =>
    apiGet('/reach-plans/record-details', {
      per_page: DEFAULT_PAGE_SIZE,
      page: 1,
      ...params,
    }).then((d) =>
      parsePaginatedResponseFull<RecordDetailItem>(d, { page: 1, per_page: DEFAULT_PAGE_SIZE }),
    ),
};
